import { createSlice } from "@reduxjs/toolkit";
import checkHospitalCredit from "@custom/rtk-apis/teleradiologist/checkHospitalCredit";

const initialState = {
  status:"",
  result:null,
  msg:"",
  loading:false,
  error:""
};

const checkHospitalCreditSlice = createSlice({
  name: "checkHospitalCreditSlice",
  initialState,
  reducers: {
    closeModal (state:any) {
       state.status = "";
       state.result = null;
       state.msg = "";
       state.loading = false;
       state.error = "";}
  },
  extraReducers: (builder) => {
    builder
      .addCase(checkHospitalCredit.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(checkHospitalCredit.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.status = payload.status;
        state.result = payload.result;
        state.msg = payload.msg;
      })
      .addCase(checkHospitalCredit.rejected, (state, { payload }) => {
        state.result = payload;
        state.loading = false;
      });
  },
});

export default checkHospitalCreditSlice.reducer;
export const { closeModal } = checkHospitalCreditSlice.actions;
